/**
 * Downloads Page JavaScript - Separate File
 * Handles search, pagination, and download functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Enhanced Downloads Manager with Fixed Functionality
  class DownloadsManager {
    constructor() {
      this.searchInput = document.getElementById('downloads-search-input');
      this.searchButton = document.getElementById('downloads-search-button');
      this.productsGrid = document.getElementById('downloads-products-grid');
      this.productCards = document.querySelectorAll('.downloads-product-card');
      this.modal = document.getElementById('downloads-modal');
      this.modalClose = document.getElementById('downloads-modal-close');
      this.modalBackdrop = document.querySelector('.downloads-modal-backdrop');
      this.modalDownloadLink = document.getElementById('downloads-modal-link');
      
      this.currentPage = 1;
      this.itemsPerPage = 30;
      this.filteredItems = Array.from(this.productCards);
      this.searchTimeout = null;
      
      console.log('Downloads Manager initialized');
      console.log('Total products found:', this.productCards.length);
      
      this.init();
    }
    
    init() {
      this.bindEvents();
      this.displayItems();
      this.updatePagination();
      this.logDebugInfo();
    }
    
    logDebugInfo() {
      console.log('=== Downloads Page Debug Info ===');
      console.log('Total product cards:', this.productCards.length);
      console.log('Items per page:', this.itemsPerPage);
      console.log('Total pages:', Math.ceil(this.productCards.length / this.itemsPerPage));
      
      // Log first few products for debugging
      Array.from(this.productCards).slice(0, 3).forEach((card, index) => {
        console.log(`Product ${index + 1}:`, {
          title: card.dataset.title,
          sku: card.dataset.sku,
          downloadUrl: card.dataset.downloadUrl,
          productId: card.dataset.productId
        });
      });
    }
    
    bindEvents() {
      // Search functionality with debounce
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => {
          clearTimeout(this.searchTimeout);
          this.searchTimeout = setTimeout(() => {
            this.performSearch();
          }, 300);
        });
        
        this.searchInput.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.performSearch();
          }
        });
      }
      
      if (this.searchButton) {
        this.searchButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.performSearch();
        });
      }
      
      // Pagination events
      this.bindPaginationEvents();
      
      // Download functionality
      this.productCards.forEach(card => {
        this.bindDownloadEvents(card);
      });
      
      // Modal events
      this.bindModalEvents();
      
      // Keyboard shortcuts
      this.bindKeyboardEvents();
    }
    
    bindPaginationEvents() {
      const prevBtn = document.getElementById('downloads-prev-btn');
      const nextBtn = document.getElementById('downloads-next-btn');
      
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToPreviousPage();
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToNextPage();
        });
      }
    }
    
    bindDownloadEvents(card) {
      const downloadBtn = card.querySelector('.downloads-overlay-btn');
      const closeBtn = card.querySelector('.downloads-overlay-close');
      const imageWrapper = card.querySelector('.downloads-product-image-wrapper');
      
      // Click on image wrapper to show download modal
      if (imageWrapper) {
        imageWrapper.addEventListener('click', (e) => {
          e.stopPropagation();
          this.handleDownloadClick(card);
        });
      }
      
      // Download button click
      if (downloadBtn) {
        downloadBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.handleDownloadClick(card);
        });
      }
      
      // Close overlay button - prevent event bubbling
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          // Just prevent the download action, overlay will hide on mouse leave
        });
      }
    }
    
    handleDownloadClick(card) {
      const downloadLink = card.dataset.downloadLink;
      const downloadUrl = card.dataset.downloadUrl;
      const productTitle = card.querySelector('.downloads-product-name')?.textContent || 'Unknown Product';
      
      console.log('Download clicked:', { downloadLink, downloadUrl, productTitle });
  
      // 优先级 1：如果 custom.download_link 存在，直接打开链接（不下载、不弹 Modal）
      if (downloadLink && downloadLink !== '#' && downloadLink !== '') {
        console.log('Opening external link:', downloadLink);
        window.open(downloadLink, '_blank', 'noopener,noreferrer');
        return;
      }
      
      // 优先级 2：否则走原来的文件下载逻辑
      if (downloadUrl && downloadUrl !== '#' && downloadUrl !== '') {
        this.openModal(downloadUrl, productTitle);
      } else {
        console.warn('No download URL found for product:', productTitle);
        alert('Download not available for this product.');
      }
    }
    
    bindModalEvents() {
      if (this.modalClose) {
        this.modalClose.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeModal();
        });
      }
      
      if (this.modalBackdrop) {
        this.modalBackdrop.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeModal();
        });
      }
    }
    
    bindKeyboardEvents() {
      document.addEventListener('keydown', (e) => {
        // Escape key to close modal
        if (e.key === 'Escape' && this.modal && this.modal.classList.contains('active')) {
          this.closeModal();
        }
        
        // Arrow keys for pagination (when not in input field)
        if (document.activeElement !== this.searchInput) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.goToPreviousPage();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.goToNextPage();
          }
        }
      });
    }
    
    performSearch() {
      const searchTerm = this.searchInput ? this.searchInput.value.toLowerCase().trim() : '';
      
      console.log('Performing search for:', searchTerm);
      
      if (searchTerm === '') {
        this.filteredItems = Array.from(this.productCards);
      } else {
        this.filteredItems = Array.from(this.productCards).filter(card => {
          const sku = card.dataset.sku || '';
          const title = card.dataset.title || '';
          const matches = sku.includes(searchTerm) || title.includes(searchTerm);
          
          if (matches) {
            console.log('Match found:', { sku, title, searchTerm });
          }
          
          return matches;
        });
      }
      
      console.log('Search results:', this.filteredItems.length, 'of', this.productCards.length);
      
      this.currentPage = 1;
      this.displayItems();
      this.updatePagination();
      this.showSearchResults(searchTerm);
    }
    
    showSearchResults(searchTerm) {
      const resultsCount = this.filteredItems.length;
      const totalCount = this.productCards.length;
      
      console.log(`Search for "${searchTerm}": ${resultsCount} of ${totalCount} products found`);
      
      // You can add a visual indicator here if needed
      // For example, update a results counter element
    }
    
    displayItems() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      
      console.log(`Displaying items ${startIndex + 1} to ${Math.min(endIndex, this.filteredItems.length)} of ${this.filteredItems.length}`);
      
      // Hide all items first
      this.productCards.forEach(card => {
        card.style.display = 'none';
      });
      
      // Show filtered items for current page
      this.filteredItems.slice(startIndex, endIndex).forEach(card => {
        card.style.display = 'block';
      });
      
      // Smooth scroll to top of grid when changing pages (but not on initial load)
      if (this.currentPage > 1 && this.productsGrid) {
        setTimeout(() => {
          this.productsGrid.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        }, 100);
      }
    }
    
    updatePagination() {
      const totalPages = Math.ceil(this.filteredItems.length / this.itemsPerPage);
      const paginationNumbers = document.getElementById('downloads-pagination-numbers');
      const prevBtn = document.getElementById('downloads-prev-btn');
      const nextBtn = document.getElementById('downloads-next-btn');
      
      console.log('Updating pagination:', { currentPage: this.currentPage, totalPages });
      
      // Update navigation buttons
      if (prevBtn) {
        prevBtn.disabled = this.currentPage === 1;
        prevBtn.style.opacity = this.currentPage === 1 ? '0.5' : '1';
      }
      
      if (nextBtn) {
        nextBtn.disabled = this.currentPage === totalPages || totalPages === 0;
        nextBtn.style.opacity = (this.currentPage === totalPages || totalPages === 0) ? '0.5' : '1';
      }
      
      // Clear and rebuild page numbers
      if (paginationNumbers) {
        paginationNumbers.innerHTML = '';
        
        if (totalPages <= 1) {
          return;
        }
        
        // Calculate which page numbers to show
        const maxVisiblePages = 5;
        let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
        
        // Adjust start page if we're near the end
        if (endPage - startPage < maxVisiblePages - 1) {
          startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }
        
        // Add first page and ellipsis if needed
        if (startPage > 1) {
          this.createPageNumber(1, paginationNumbers);
          if (startPage > 2) {
            this.createEllipsis(paginationNumbers);
          }
        }
        
        // Add visible page numbers
        for (let i = startPage; i <= endPage; i++) {
          this.createPageNumber(i, paginationNumbers);
        }
        
        // Add last page and ellipsis if needed
        if (endPage < totalPages) {
          if (endPage < totalPages - 1) {
            this.createEllipsis(paginationNumbers);
          }
          this.createPageNumber(totalPages, paginationNumbers);
        }
      }
    }
    
    createPageNumber(pageNum, container) {
      const pageSpan = document.createElement('span');
      pageSpan.className = `downloads-page-number ${pageNum === this.currentPage ? 'downloads-page-active' : ''}`;
      pageSpan.textContent = pageNum;
      pageSpan.dataset.page = pageNum;
      pageSpan.style.cursor = 'pointer';
      
      pageSpan.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToPage(pageNum);
      });
      
      container.appendChild(pageSpan);
    }
    
    createEllipsis(container) {
      const ellipsis = document.createElement('span');
      ellipsis.textContent = '...';
      ellipsis.className = 'downloads-pagination-ellipsis';
      ellipsis.style.padding = '10px 5px';
      ellipsis.style.color = '#999';
      ellipsis.style.fontWeight = '500';
      container.appendChild(ellipsis);
    }
    
    goToPage(pageNum) {
      console.log('Going to page:', pageNum);
      this.currentPage = pageNum;
      this.displayItems();
      this.updatePagination();
    }
    
    goToPreviousPage() {
      if (this.currentPage > 1) {
        console.log('Going to previous page');
        this.currentPage--;
        this.displayItems();
        this.updatePagination();
      }
    }
    
    goToNextPage() {
      const totalPages = Math.ceil(this.filteredItems.length / this.itemsPerPage);
      if (this.currentPage < totalPages) {
        console.log('Going to next page');
        this.currentPage++;
        this.displayItems();
        this.updatePagination();
      }
    }
    
    openModal(downloadUrl, productTitle) {
      console.log('Opening modal for:', { downloadUrl, productTitle });
      
      if (this.modalDownloadLink) {
        this.modalDownloadLink.href = downloadUrl;
        this.modalDownloadLink.download = ''; // Let browser determine filename
      }
      
      // Update modal title
      const modalTitle = this.modal ? this.modal.querySelector('.downloads-modal-header h3') : null;
      if (modalTitle) {
        modalTitle.textContent = `Download: ${productTitle}`;
      }
      
      if (this.modal) {
        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
    
    closeModal() {
      console.log('Closing modal');
      
      if (this.modal) {
        this.modal.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
    }
    
    // Utility method to refresh the downloads list (useful for dynamic content)
    refresh() {
      console.log('Refreshing downloads manager');
      
      this.productCards = document.querySelectorAll('.downloads-product-card');
      this.filteredItems = Array.from(this.productCards);
      this.currentPage = 1;
      
      // Rebind events for new items
      this.productCards.forEach(card => {
        this.bindDownloadEvents(card);
      });
      
      this.displayItems();
      this.updatePagination();
      this.logDebugInfo();
    }
    
    // Method to get current state (useful for debugging)
    getState() {
      return {
        totalProducts: this.productCards.length,
        filteredProducts: this.filteredItems.length,
        currentPage: this.currentPage,
        itemsPerPage: this.itemsPerPage,
        totalPages: Math.ceil(this.filteredItems.length / this.itemsPerPage),
        searchTerm: this.searchInput ? this.searchInput.value : ''
      };
    }
  }
  
  // Initialize the downloads manager
  try {
    window.downloadsManager = new DownloadsManager();
    console.log('Downloads Manager successfully initialized');
    
    // Expose debug methods to console
    window.debugDownloads = () => {
      console.log('Current state:', window.downloadsManager.getState());
    };
    
    window.refreshDownloads = () => {
      window.downloadsManager.refresh();
    };
    
  } catch (error) {
    console.error('Error initializing Downloads Manager:', error);
  }
  
  // Additional utility functions
  
  // Function to handle image loading errors
  function handleImageError(img) {
    console.warn('Image failed to load:', img.src);
    
    // Try to find a fallback image or show placeholder
    const card = img.closest('.downloads-product-card');
    if (card) {
      const wrapper = img.closest('.downloads-product-image-wrapper');
      if (wrapper) {
        wrapper.innerHTML = `
          <div class="downloads-product-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21,15 16,10 5,21"></polyline>
            </svg>
            <p>Image not available</p>
          </div>
        `;
      }
    }
  }
  
  // Bind error handlers to all images
  document.querySelectorAll('.downloads-product-image').forEach(img => {
    img.addEventListener('error', () => handleImageError(img));
  });
  
  // Performance monitoring
  if (window.performance && window.performance.mark) {
    window.performance.mark('downloads-page-loaded');
  }
  
  console.log('Downloads page JavaScript fully loaded');
});

